/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import {

    getUserInfo,
    logout
} from "./userAction";

const userSlice = createSlice({
    name: 'user',
    initialState: {
        user: {},
        usersInfo: [],
        loggedin: false,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserInfo.fulfilled, (state, action) => {
                 state.user = action.payload;
                if (action.payload && Object.keys(action.payload).length > 0) {
 
                    state.loginned = true;
                } else {
                    state.loginned = false;

                } 
            })
            .addCase(getUserInfo.rejected, (state, action) => {
                console.error('Error fetching user info:', action.error.message);
                state.user = {};
                state.loginned = false;
            })
            .addCase(logout.fulfilled, (state) => {
                state.user = {};
                state.loginned = false;
            })
            .addCase(logout.rejected, (state, action) => {
                console.error('Error logging out:', action.error.message);
            });;
    },
});


export default userSlice.reducer